module.exports = __webpack_public_path__ + "static/site-image-9d86c3976ce69e1c1ba1b216b6a12db2.jpg";